module.exports = __webpack_public_path__ + "img/paid2.e3408510.svg";